/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllOrgsUsers = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-user/getAll`,param).then(res => res.data)
}
const getAllOrgsUsersByOrgID = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-user/getAllByOrganizationID`,param).then(res => res.data)
}
const getOrgUserHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-user/get-history`,param).then(res => res.data)
}
const createOrgUsers = (orgApp) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-user/create`,orgApp).then(res => res.data)
}
const editOrgUsers = (orgApp) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-user/update`,orgApp).then(res => res.data)
}
export {
    getAllOrgsUsers,
    createOrgUsers,
    editOrgUsers,
    getAllOrgsUsersByOrgID,
    getOrgUserHistory
}
